var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlTravelers = function SvgVaknlTravelers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5a.398.398 0 0 1-.011.114 4 4 0 0 1-4.049 3.74A3.998 3.998 0 0 1 6 5a2.78 2.78 0 0 1 .057-.617 3.976 3.976 0 0 1 2.96-3.257C9.338 1.043 9.668 1 10 1c2.21 0 4 1.79 4 4zm3.389 12.922v-.533A7.41 7.41 0 0 0 10 10a7.41 7.41 0 0 0-7.389 7.389v.533A1.58 1.58 0 0 0 4.189 19.5h11.622a1.58 1.58 0 0 0 1.578-1.578z"
  })));
};
export default SvgVaknlTravelers;